import type { RefObject } from 'react';

import { AIActive } from '../../../../assets/svgs/AIActive';
import { cn } from '@/lib/utils';

interface ShellBubbleProps {
  /** Extra classes; the mobile nav row styles its copy as a row child. */
  className?: string;
  /** The shell hands focus back here when the window is minimized. */
  buttonRef?: RefObject<HTMLButtonElement>;
  /** Hidden (but kept mounted, so it can crossfade) while a window is open. */
  isHidden: boolean;
  onClick: () => void;
  /**
   * Badge count. Always 0 in phase 1 — the Intercom unread count arrives with
   * human mode (phase 2) and the slot exists so the layout is settled first.
   */
  unreadCount?: number;
}

/** The launcher. 56px, bottom-right, glass — the shell's only resting state. */
const ShellBubble = ({
  buttonRef,
  className,
  isHidden,
  onClick,
  unreadCount = 0,
}: ShellBubbleProps) => (
  <button
    ref={buttonRef}
    type="button"
    onClick={onClick}
    aria-label="Open AI Chat (c)"
    aria-hidden={isHidden}
    {...((isHidden ? { inert: '' } : {}) as Record<string, string>)}
    className={cn('companion-shell_bubble', isHidden && 'is-hidden', className)}
  >
    <AIActive />
    {unreadCount > 0 ? (
      <span className="companion-shell_bubble_badge" aria-hidden="true">
        {unreadCount > 9 ? '9+' : unreadCount}
      </span>
    ) : null}
  </button>
);

export default ShellBubble;
